module.exports = __webpack_public_path__ + "media/images/Bars/icon-back-incircle@2x-00363b828ca59a7cd70a4f4a3d06b4f5.png";